import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { PriceTargetItem } from '../../shared/models';


/**
 * Injectable service to handle price target data from the API
 */
@Injectable({
  providedIn: 'root'
})
export class PriceTargetsService extends RmsBasicCrudService<PaginatedList<PriceTargetItem>> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets the Price Targets Data
   * Common params: TYPE: string, egt: number, elt: number
   * @param params
   * @returns {Observable<PaginatedList<PriceTargetItem>>}
   */
  public getPriceTargets (params?: any): Observable<PaginatedList<PriceTargetItem>> {
    return super.getData('/api/rms/pricetargets', params);
  }

}
